/**
 * Ayuda — Administración → Cobros
 */

import { ADM_COL_VOUCHERS_ITEM } from './adm-col-vouchers.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ADM_COL_HELP = {
  screenId: 'adm-col',
  label: 'Cobros',
  navPath: 'Administración → Cobros',
  keywords: [
    'cobro', 'cobros', 'recibo', 'recibos', 'cobrar', 'cliente', 'efectivo',
    'transferencia', 'imputación', 'factura pendiente', 'anticipo',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Cobros registrás los recibos cuando un cliente te paga. El menú de la izquierda tiene la opción Recibos. Tocá abajo para ver el paso a paso.',
  sidebarItems: [ADM_COL_VOUCHERS_ITEM],
}
